/* ═══════════════════════════════════════════════════════════════════
   BALNCE — Cart (v37.6 : live header cart count sync — desktop "(X)" + mobile bulle)

   - Intercepte la soumission de #pdp-product-form (PDP Kit)
     → construit items[] : [Kit] + [Phase2/3/Pack23 si radio] + [Guide si checkbox]
     → POST /cart/add.js avec sections pour re-render le drawer
     → appelle cartDrawer.renderContents() et ouvre le drawer

   - Intercepte les clicks sur .cart-upsell__add[data-variant-id]
     (boutons upsell dans le drawer — PAS des forms, pour éviter
     le nested-form-parser-strip qui redirigeait vers /cart)
     → même flux AJAX, panier mis à jour sans reload

   - v35 : quand la quantité d'un line item du drawer tombe à 0 (click
     sur "−" quand qty=1, ou saisie manuelle "0"), on intercepte AVANT
     Dawn (qui rejette avec "Cet article a un minimum de 1") et on
     appelle /cart/change.js avec quantity=0 pour retirer proprement.

   - v37 : quand un bouton upsell porte data-remove-vid="<id1>,<id2>",
     on appelle d'abord /cart/update.js pour mettre ces variants à qty=0
     (retire la Phase 2 ou 3 déjà dans le panier) PUIS /cart/add.js pour
     ajouter le Pack upgrade. Évite la double facturation de la phase.

   - v37.3 : intercepte aussi #balnce-prog-form (PDP Programme) :
       → lit data-phase-input (phase2/phase3/pack23), résout le variant
         correspondant via data-vid-phase2/3/pack23 sur le root section
       → si data-kit-input = "1", ajoute aussi le Kit via data-vid-kit
       → items[] construit, /cart/add.js, drawer ouvert
     Sans ça le submit natif renvoie sur /cart (expérience cassée).

   - v37.5 : synchronise la bulle orange .balnce-header__cart-badge en
     temps réel sur l'event 'cart:updated'. cart-drawer.js ne re-render
     que ['cart-drawer', 'cart-icon-bubble'] — pas balnce-header — donc
     sans ça la bulle resterait figée sur la valeur d'à l'arrivée.
     On met aussi à jour la classe .has-items sur .balnce-header__cart.

   - v37.6 : synchronise aussi [data-header-cart-count] qui affiche
     "(X)" dans le label texte "Panier (X)" sur desktop. La bulle orange
     est masquée en desktop (CSS) et n'est visible qu'en mobile où le
     label texte est caché.

   - Compatible avec balnce-behaviors.js qui poll window.BALNCE_CART.open()
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var events = new EventTarget();

  /* ─── Helpers ──────────────────────────────────────────────────── */

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getSectionsToFetch() {
    var drawer = getCartDrawer();
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') {
      return ['cart-drawer', 'cart-icon-bubble'];
    }
    return drawer.getSectionsToRender().map(function (s) { return s.id; });
  }

  function openDrawer() {
    var drawer = getCartDrawer();
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  function clearCartErrors() {
    // Clear Dawn's generic cart errors node + any per-line errors so that
    // a stale "Une erreur est survenue" message doesn't linger after success.
    document.querySelectorAll(
      '#CartDrawer-CartErrors, [id^="CartDrawer-LineItemError-"], .cart-item__error, #cart-errors'
    ).forEach(function (node) {
      node.textContent = '';
      node.innerHTML = '';
    });
  }

  function dispatchCartUpdated(cartData) {
    // Shopify Dawn pub/sub
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      try {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'balnce-cart',
          cartData: cartData,
        });
      } catch (e) { /* noop */ }
    }
    // BALNCE native event
    events.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
    // Mise à jour shipping progress
    updateShippingProgress(cartData);
    // Mise à jour bulle orange du header (v37.5)
    updateHeaderCartBadge(cartData);
    // ─── FIX PANIER (is-empty) ───────────────────────────────────────
    // Le re-rendu AJAX remplaçait le contenu du drawer mais laissait la
    // classe "is-empty" sur l'élément <cart-drawer> lui-même lors du
    // passage panier vide → non-vide. Or un CSS "cart-drawer.is-empty"
    // déforme le bloc article (largeur pleine page) → l'article se
    // retrouve hors du panneau visible et paraît absent tant qu'on ne
    // rafraîchit pas. On synchronise donc la classe depuis le compte réel.
    var _cd = getCartDrawer();
    if (_cd && cartData && typeof cartData.item_count === 'number') {
      _cd.classList.toggle('is-empty', cartData.item_count === 0);
    }
    // Clear stale errors
    clearCartErrors();
    // v38-120 : filet de sécurité côté serveur — DÉSACTIVÉ en v38-122
    // (causait des race conditions qui rendaient le drawer vide).
    // Le pré-check JS dans bindNutriForm/bindProgrammeForm/handleUpsellClick
    // suffit pour empêcher l'accumulation.
    // enforceMaxQtyDigital(cartData);
  }

  /* ─── v38-120 : Filet de sécurité qty=1 pour produits digitaux ─────
     Même si le pré-check JS échoue (cache, race condition), Shopify normalise
     à 1 dès qu'on détecte qty > 1 sur un produit dont le handle/titre contient
     "guide", "phase", ou "pack" (programmes digitaux + guide nutrition).
     Le Kit n'est jamais normalisé (produit physique multi-quantity OK). */
  var _enforceMaxRunning = false;
  function enforceMaxQtyDigital(cartData) {
    if (_enforceMaxRunning) return;
    if (!cartData || !cartData.items) return;
    var updates = {};
    cartData.items.forEach(function (it) {
      var handle = (it.handle || '').toLowerCase();
      var title  = (it.product_title || '').toLowerCase();
      var isDigital = handle.indexOf('guide') !== -1 || title.indexOf('guide') !== -1
                   || handle.indexOf('phase') !== -1 || title.indexOf('phase') !== -1
                   || handle.indexOf('pack') !== -1  || title.indexOf('pack') !== -1
                   || handle.indexOf('programme') !== -1 || title.indexOf('programme') !== -1;
      // Exclusion explicite du Kit (au cas où un title contient "Kit BALNCE Pack").
      var isKit = handle.indexOf('kit') !== -1 || title.indexOf('kit') !== -1;
      if (isDigital && !isKit && it.quantity > 1) {
        updates[String(it.variant_id)] = 1;
      }
    });
    if (Object.keys(updates).length === 0) return;
    _enforceMaxRunning = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        // Re-render le drawer avec le cart corrigé.
        return fetch('/?sections=' + getSectionsToFetch().join(','))
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            var drawer = getCartDrawer();
            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.renderContents({ sections: sections, items: cart.items });
            }
            updateHeaderCartBadge(cart);
            updateShippingProgress(cart);
          });
      })
      .catch(function (e) { console.warn('[BALNCE_CART] enforceMaxQty failed:', e); })
      .finally(function () { _enforceMaxRunning = false; });
  }

  /* ─── v37.5 : sync bulle orange du header ─────────────────────
     cart-drawer.js ne re-render pas balnce-header, donc on le fait ici. */
  function updateHeaderCartBadge(cartData) {
    var count = (cartData && typeof cartData.item_count === 'number') ? cartData.item_count : null;
    if (count === null) {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        updateHeaderCartBadge(cart);
      }).catch(function () { });
      return;
    }
    document.querySelectorAll('.balnce-header__cart-badge').forEach(function (el) {
      el.textContent = String(count);
    });
    // v37.6 : "(X)" dans le label texte desktop "Panier (X)"
    document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
      el.textContent = '(' + count + ')';
    });
    document.querySelectorAll('.balnce-header__cart').forEach(function (btn) {
      if (count > 0) btn.classList.add('has-items');
      else btn.classList.remove('has-items');
    });
  }

  function updateShippingProgress(cartData) {
    var total = (cartData && typeof cartData.total_price === 'number') ? cartData.total_price : null;
    if (total === null) {
      // Fallback : fetch /cart.js
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        updateShippingProgress(cart);
      });
      return;
    }

    document.querySelectorAll('[data-balnce-shipping-progress]').forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 10000;
      var locked = bar.getAttribute('data-label-locked') || 'Plus que {amount} pour la livraison offerte';
      var unlocked = bar.getAttribute('data-label-unlocked') || '🎉 Livraison offerte débloquée';

      var remaining = Math.max(0, threshold - total);
      var pct = Math.min(100, (total * 100) / threshold);

      var fill = bar.querySelector('[data-ship-fill]');
      var label = bar.querySelector('[data-ship-label]');

      if (fill) fill.style.width = pct + '%';

      if (total >= threshold) {
        bar.classList.add('is-unlocked');
        if (label) label.innerHTML = unlocked;
      } else {
        bar.classList.remove('is-unlocked');
        if (label) {
          var amount = formatMoney(remaining);
          label.innerHTML = locked.replace('{amount}', amount);
        }
      }
    });
  }

  function formatMoney(cents) {
    // Simple EUR formatting (match mockup : "73€" no space)
    var val = cents / 100;
    if (val === Math.floor(val)) return val + '€';
    return val.toFixed(2).replace('.', ',') + '€';
  }

  /* ─── Core : post items[] to /cart/add.js ─────────────────────── */

  function addItemsToCart(items, triggerButton) {
    if (!items || items.length === 0) return Promise.reject(new Error('No items'));

    var body = new FormData();
    items.forEach(function (it, idx) {
      body.append('items[' + idx + '][id]', String(it.id));
      body.append('items[' + idx + '][quantity]', String(it.quantity || 1));
    });

    body.append('sections', getSectionsToFetch().join(','));
    body.append('sections_url', window.location.pathname);

    if (triggerButton) {
      triggerButton.setAttribute('aria-busy', 'true');
      triggerButton.classList.add('is-loading');
      // v38-117 : disabled = true pour empêcher multi-clic pendant l'AJAX
      triggerButton.disabled = true;
    }

    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) {
          // Error
          console.error('[BALNCE_CART] /cart/add error:', response);
          var msg = response.description || response.message || 'Erreur lors de l\'ajout au panier.';
          alert(msg);
          throw new Error(msg);
        }

        // v38-125 : retour pattern Dawn standard
        var drawer = getCartDrawer();
        if (drawer && typeof drawer.renderContents === 'function' && response.sections) {
          drawer.renderContents(response);
        } else {
          openDrawer();
        }
        // FIX PANIER (is-empty) : on vient d'ajouter au moins un article,
        // donc le drawer n'est plus vide. On retire la classe tout de suite
        // (avant même le fetch /cart.js) pour éviter tout flash d'article
        // mal positionné hors du panneau.
        if (drawer) drawer.classList.remove('is-empty');

        // Ouverture propre, une seule fois. L'ancienne "valse close/open"
        // (v38-126) provoquait un flash de contenu décalé/coupé pendant
        // l'animation de glissement ; elle n'est plus nécessaire depuis le
        // FIX is-empty (le "phantom display" venait de là). On ouvre net.
        if (drawer && typeof drawer.open === 'function') {
          try { drawer.open(); } catch (e) {}
        }

        // Fetch fresh cart.js for totals, then dispatch update
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          dispatchCartUpdated(cart);
          return cart;
        });
      })
      .catch(function (err) {
        console.error('[BALNCE_CART] add error', err);
        throw err;
      })
      .finally(function () {
        if (triggerButton) {
          triggerButton.removeAttribute('aria-busy');
          triggerButton.classList.remove('is-loading');
          // v38-117 : ré-active le bouton après la réponse (succès ou échec)
          triggerButton.disabled = false;
        }
      });
  }

  /* v38-125 : Fonctions refreshCartDrawer / replaceDrawerInner supprimées —
     elles causaient des bugs de layout (items centrés, décalés à gauche). */

  /* ─── v37 : Replace (update qty=0 + add Pack) ─────────────────
     Usage : bouton upsell "Passer au Pack" avec data-remove-vid="<id1>,<id2>"
     1) POST /cart/update.js { updates: { <id>: 0, ... } } → retire les phases
     2) POST /cart/add.js items[]=Pack → ajoute le Pack (+ renvoie sections
        re-rendues par Shopify → drawer refresh propre)
     Les deux appels sont séquentiels pour éviter les races (update puis add).
     On ne ré-ouvre pas le drawer : il est déjà ouvert. */

  function replaceCartLines(removeVariantIds, itemsToAdd, triggerButton) {
    if (!itemsToAdd || itemsToAdd.length === 0) return Promise.reject(new Error('No items to add'));

    if (triggerButton) {
      triggerButton.setAttribute('aria-busy', 'true');
      triggerButton.classList.add('is-loading');
      // v38-117 : disabled = true pour empêcher multi-clic pendant l'AJAX
      triggerButton.disabled = true;
    }

    var updates = {};
    (removeVariantIds || []).forEach(function (vid) {
      if (vid) updates[String(vid)] = 0;
    });

    var removePromise;
    if (Object.keys(updates).length > 0) {
      removePromise = fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: updates })
      }).then(function (res) { return res.json(); });
    } else {
      removePromise = Promise.resolve(null);
    }

    return removePromise
      .then(function () {
        // Étape 2 : ajout du Pack avec sections pour render du drawer
        var body = new FormData();
        itemsToAdd.forEach(function (it, idx) {
          body.append('items[' + idx + '][id]', String(it.id));
          body.append('items[' + idx + '][quantity]', String(it.quantity || 1));
        });
        body.append('sections', getSectionsToFetch().join(','));
        body.append('sections_url', window.location.pathname);

        return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: body
        }).then(function (res) { return res.json(); });
      })
      .then(function (response) {
        if (response.status) {
          console.error('[BALNCE_CART] replace /cart/add error:', response);
          var msg = response.description || response.message || 'Erreur lors du remplacement.';
          alert(msg);
          throw new Error(msg);
        }

        // v38-125 : retour Dawn standard
        var drawer = getCartDrawer();
        if (drawer && typeof drawer.renderContents === 'function' && response.sections) {
          drawer.renderContents(response);
        }

        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          dispatchCartUpdated(cart);
          return cart;
        });
      })
      .catch(function (err) {
        console.error('[BALNCE_CART] replace error', err);
        throw err;
      })
      .finally(function () {
        if (triggerButton) {
          triggerButton.removeAttribute('aria-busy');
          triggerButton.classList.remove('is-loading');
          // v38-117 : ré-active le bouton après la réponse
          triggerButton.disabled = false;
        }
      });
  }

  /* ─── PDP form intercept (Kit + Guide nutrition) ──────────────── */

  function bindPdpForm() {
    var form = document.getElementById('pdp-product-form');
    if (!form || form.dataset.balnceBound === '1') return;
    form.dataset.balnceBound = '1';

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();

      // v38-117 : verrou anti-multi-clic IMMÉDIAT
      if (form.dataset.balnceSubmitting === '1') return;
      form.dataset.balnceSubmitting = '1';

      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      // v38-127 : pré-check /cart.js pour éviter les doublons si le form Kit
      // est soumis plusieurs fois (ex : changement d'option puis re-clic sur
      // Précommander). Le Kit form n'avait pas cette protection contrairement
      // à bindNutriForm/bindProgrammeForm, ce qui pouvait dupliquer le Guide
      // nutrition (PDF → max qty = 1) et fausser le total du panier.
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var existingVids = (cart.items || []).map(function (it) { return String(it.variant_id); });
          var items = [];

          // 1. Kit (main product variant)
          var idInput = form.querySelector('input[name="id"]');
          if (idInput && idInput.value) {
            items.push({ id: idInput.value, quantity: 1 });
          }

          // 2. Phase radio (phase2 / phase3 / pack23)
          var phaseRadio = form.querySelector('input[name="pdp_phase"]:checked');
          if (phaseRadio) {
            var phaseVariantId = phaseRadio.getAttribute('data-variant-id');
            if (phaseVariantId && phaseVariantId.trim() !== '') {
              var pvid = phaseVariantId.trim();
              if (existingVids.indexOf(pvid) === -1) {
                items.push({ id: pvid, quantity: 1 });
              }
            } else {
              console.warn('[BALNCE_CART] Radio phase sélectionnée mais data-variant-id vide. Vérifie les settings section PDP.');
            }
          }

          // 3. Guide nutrition checkbox (PDF → max qty = 1, ne jamais dupliquer)
          var nutriCheckbox = form.querySelector('input[name="pdp_extra_nutri"]');
          if (nutriCheckbox && nutriCheckbox.checked) {
            var nutriVariantId = nutriCheckbox.getAttribute('data-variant-id');
            if (nutriVariantId && nutriVariantId.trim() !== '') {
              var nvid = nutriVariantId.trim();
              if (existingVids.indexOf(nvid) === -1) {
                items.push({ id: nvid, quantity: 1 });
              }
            } else {
              console.warn('[BALNCE_CART] Guide nutrition coché mais data-variant-id vide. Vérifie les settings.');
            }
          }

          // 4. Phase 3 checkbox (mode précommande uniquement : additive, en plus
          //    de la Phase 2 offerte du radio "pdp_phase" — voir balnce-pdp-hero.liquid)
          //    Produit digital → max qty = 1, ne jamais dupliquer.
          var phase3Checkbox = form.querySelector('input[name="pdp_extra_phase3"]');
          if (phase3Checkbox && phase3Checkbox.checked) {
            var phase3VariantId = phase3Checkbox.getAttribute('data-variant-id');
            if (phase3VariantId && phase3VariantId.trim() !== '') {
              var p3vid = phase3VariantId.trim();
              if (existingVids.indexOf(p3vid) === -1) {
                items.push({ id: p3vid, quantity: 1 });
              }
            } else {
              console.warn('[BALNCE_CART] Phase 3 cochée mais data-variant-id vide. Vérifie les settings section PDP.');
            }
          }

          if (items.length === 0) {
            console.warn('[BALNCE_CART] Aucun item à ajouter (tout est déjà dans le panier).');
            openDrawer();
            form.dataset.balnceSubmitting = '0';
            if (submitBtn) submitBtn.disabled = false;
            return;
          }

          return addItemsToCart(items, submitBtn)
            .catch(function () { /* already handled */ })
            .finally(function () {
              form.dataset.balnceSubmitting = '0';
            });
        });
    });
  }

  /* ─── Nutrition Guide PDP form intercept (v36) ────────────────
     Le form #balnce-nutri-hero-form ajoute :
       - Le Guide (variant principal via name="id")
       - Si la checkbox Kit est active (data-bb-kit-input value="1"),
         on ajoute aussi le Kit via data-bb-kit-vid (résolu en Liquid).
     Sans ça, le submit default redirige vers /cart → expérience cassée. */

  function bindNutriForm() {
    var form = document.getElementById('balnce-nutri-hero-form');
    if (!form || form.dataset.balnceBound === '1') return;
    form.dataset.balnceBound = '1';

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();

      // v38-117 : verrou anti-multi-clic IMMÉDIAT (avant tout AJAX)
      // Si une soumission est en cours, on ignore le nouveau clic.
      if (form.dataset.balnceSubmitting === '1') return;
      form.dataset.balnceSubmitting = '1';

      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      // 1. Guide (main product variant)
      var idInput = form.querySelector('input[name="id"]');
      var guideVid = (idInput && idInput.value) ? String(idInput.value) : '';

      // 2. Kit addon (si la checkbox Kit est activée)
      var kitInput = form.querySelector('[data-bb-kit-input]');
      var kitVidInput = form.querySelector('[data-bb-kit-vid]');
      var wantsKit = kitInput && kitInput.value === '1';
      var kitVid = (wantsKit && kitVidInput) ? String(kitVidInput.value || '').trim() : '';

      if (!guideVid && !kitVid) {
        console.warn('[BALNCE_CART] Nutri form : aucun item à ajouter.');
        form.dataset.balnceSubmitting = '0';
        if (submitBtn) submitBtn.disabled = false;
        return;
      }

      // v38-118 : pré-check /cart.js pour éviter d'ajouter ce qui est déjà dedans
      // (Guide est un PDF → max qty = 1 par client).
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var existingVids = (cart.items || []).map(function (it) { return String(it.variant_id); });
          var items = [];
          if (guideVid && existingVids.indexOf(guideVid) === -1) {
            items.push({ id: guideVid, quantity: 1 });
          }
          if (kitVid && existingVids.indexOf(kitVid) === -1) {
            items.push({ id: kitVid, quantity: 1 });
          }

          if (items.length === 0) {
            // Rien à ajouter : tout est déjà dans le panier. On ouvre juste le drawer.
            openDrawer();
            form.dataset.balnceSubmitting = '0';
            if (submitBtn) submitBtn.disabled = false;
            return;
          }

          return addItemsToCart(items, submitBtn)
            .catch(function () { /* handled */ })
            .finally(function () {
              form.dataset.balnceSubmitting = '0';
            });
        });
    });
  }

  /* ─── Programme PDP form intercept (v37.3) ────────────────────────
     Le form #balnce-prog-form pose 3 hidden inputs :
       - name="id"            → variante par défaut du produit Programme
       - name="pdp_phase"     → "phase2" | "phase3" | "pack23" (ou vide)
       - name="pdp_kit_in_order" → "1" (kit à ajouter) | "0" (déjà possédé)
     Ces champs pdp_* ne sont pas standards Shopify → le submit natif
     ajouterait seulement la variante par défaut et renverrait sur /cart.
     On intercepte : on mappe pdp_phase → variant id via data-vid-* sur
     le root [data-balnce-prog-hero], on ajoute le Kit si demandé, puis
     POST /cart/add.js avec sections → drawer re-render. */

  function bindProgrammeForm() {
    var form = document.getElementById('balnce-prog-form');
    if (!form || form.dataset.balnceBound === '1') return;
    form.dataset.balnceBound = '1';

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();

      // v38-117 : verrou anti-multi-clic IMMÉDIAT
      if (form.dataset.balnceSubmitting === '1') return;
      form.dataset.balnceSubmitting = '1';

      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      var root = form.closest('[data-balnce-prog-hero]') ||
                 document.querySelector('[data-balnce-prog-hero]');

      // 1. Phase selection (phase2 / phase3 / pack23 → variant id)
      var phaseInput = form.querySelector('[data-phase-input]');
      var phase = phaseInput ? (phaseInput.value || '').trim() : '';
      var phaseVid = '';
      if (phase && root) {
        phaseVid = (root.getAttribute('data-vid-' + phase) || '').trim();
      }
      if (!phaseVid && phase) {
        console.warn('[BALNCE_CART] Programme form : phase "' + phase + '" sélectionnée mais data-vid-' + phase + ' vide. Vérifie que les variantes du produit Programme ont un titre reconnaissable (phase 2 / phase 3 / pack / 2 & 3).');
      }

      // 2. Kit addon (si la checkbox "j'ai déjà le Kit" est DÉCOCHÉE)
      var kitInput = form.querySelector('[data-kit-input]');
      var kitInOrder = kitInput ? kitInput.value === '1' : false;
      var kitVid = '';
      if (kitInOrder) {
        kitVid = root ? (root.getAttribute('data-vid-kit') || '').trim() : '';
        if (!kitVid) {
          console.warn('[BALNCE_CART] Programme form : Kit requis mais data-vid-kit vide. Sélectionne le "Produit Kit" dans les settings globaux > Cart drawer upsells.');
        }
      }

      if (!phaseVid && !kitVid) {
        console.warn('[BALNCE_CART] Programme form : aucun item à ajouter. L\'utilisateur doit choisir une phase ou cocher le Kit.');
        form.dataset.balnceSubmitting = '0';
        if (submitBtn) submitBtn.disabled = false;
        return;
      }

      // v38-126 : Anti-doublon strict + auto-replace selon cahier des charges.
      // Récupère IDs de toutes les phases pour identifier qui est dans le cart.
      var packVidStr   = root ? (root.getAttribute('data-vid-pack23') || '').trim() : '';
      var phase2VidStr = root ? (root.getAttribute('data-vid-phase2') || '').trim() : '';
      var phase3VidStr = root ? (root.getAttribute('data-vid-phase3') || '').trim() : '';

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var existingVids = (cart.items || []).map(function (it) { return String(it.variant_id); });
          var has_pack   = packVidStr   && existingVids.indexOf(packVidStr)   !== -1;
          var has_phase2 = phase2VidStr && existingVids.indexOf(phase2VidStr) !== -1;
          var has_phase3 = phase3VidStr && existingVids.indexOf(phase3VidStr) !== -1;

          var items = [];
          var removeIds = [];

          // Phase 2 demandée
          if (phase === 'phase2') {
            if (has_phase2) { /* déjà → skip */ }
            else if (has_pack) {
              alert('Le Pack Phases 2 & 3 contient déjà la Phase 2.');
              form.dataset.balnceSubmitting = '0';
              if (submitBtn) submitBtn.disabled = false;
              openDrawer();
              return;
            } else if (phaseVid) {
              items.push({ id: phaseVid, quantity: 1 });
            }
          }
          // Phase 3 demandée
          else if (phase === 'phase3') {
            if (has_phase3) { /* déjà → skip */ }
            else if (has_pack) {
              alert('Le Pack Phases 2 & 3 contient déjà la Phase 3.');
              form.dataset.balnceSubmitting = '0';
              if (submitBtn) submitBtn.disabled = false;
              openDrawer();
              return;
            } else if (phaseVid) {
              items.push({ id: phaseVid, quantity: 1 });
            }
          }
          // Pack 2&3 demandé → auto-replace les phases si présentes
          else if (phase === 'pack23') {
            if (has_pack) { /* déjà → skip */ }
            else {
              if (has_phase2) removeIds.push(phase2VidStr);
              if (has_phase3) removeIds.push(phase3VidStr);
              if (phaseVid) items.push({ id: phaseVid, quantity: 1 });
            }
          }

          // Kit toujours autorisé en multiple
          if (kitVid) items.push({ id: kitVid, quantity: 1 });

          if (items.length === 0 && removeIds.length === 0) {
            openDrawer();
            form.dataset.balnceSubmitting = '0';
            if (submitBtn) submitBtn.disabled = false;
            return;
          }

          var op;
          if (removeIds.length > 0) {
            op = replaceCartLines(removeIds, items, submitBtn);
          } else {
            op = addItemsToCart(items, submitBtn);
          }
          return op.catch(function () { /* handled */ })
            .finally(function () {
              form.dataset.balnceSubmitting = '0';
            });
        });
    });
  }

  /* ─── Upsell buttons in drawer intercept ──────────────────────── */

  /* Les upsells sont rendus DANS #CartDrawer-Form (form de checkout Dawn).
     HTML interdit les forms imbriqués → si on met un <form> par upsell, le
     parser les strip silencieusement et le submit button se rattache au
     form extérieur qui a action="/cart" → redirect catastrophe.
     Solution : les upsells ne sont PAS des forms. Ce sont des boutons
     <button type="button" data-variant-id="…"> et on écoute le click
     en délégation sur document (capture phase pour tomber en premier). */
  function handleUpsellClick(evt) {
    var btn = evt.target && evt.target.closest
      ? evt.target.closest('.cart-upsell__add[data-variant-id]')
      : null;
    if (!btn) return;
    if (evt._balnceHandled) return;
    evt._balnceHandled = true;
    evt.preventDefault();
    evt.stopPropagation();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    // v37 : si le bouton porte data-remove-vid, on est en mode "upgrade"
    // (Phase 2 ou 3 déjà au panier → on la retire AVANT d'ajouter le Pack).
    var removeCsv = btn.getAttribute('data-remove-vid') || '';
    var removeIds = removeCsv.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (removeIds.length > 0) {
      replaceCartLines(removeIds, [{ id: variantId, quantity: 1 }], btn)
        .catch(function () { /* handled */ });
      return;
    }

    // v38-119 : pré-check qty=1 max pour produits digitaux (Guide, Phase 2/3, Pack).
    // Le Kit (bouton avec data-allow-duplicate="true") est exempté → peut être en plusieurs.
    var allowDuplicate = btn.getAttribute('data-allow-duplicate') === 'true';
    if (allowDuplicate) {
      addItemsToCart([{ id: variantId, quantity: 1 }], btn).catch(function () { /* handled */ });
      return;
    }

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var existingVids = (cart.items || []).map(function (it) { return String(it.variant_id); });
        if (existingVids.indexOf(String(variantId)) !== -1) {
          // Déjà en panier → on ouvre juste le drawer, on n'ajoute pas.
          openDrawer();
          return;
        }
        return addItemsToCart([{ id: variantId, quantity: 1 }], btn).catch(function () { /* handled */ });
      });
  }
  document.addEventListener('click', handleUpsellClick, true);

  /* Belt-and-suspenders : si un ancien markup (form-based) réapparaît via
     une section cache Shopify, on capture aussi les submit pour éviter le
     redirect vers /cart. */
  function handleUpsellSubmit(evt) {
    var form = evt.target;
    if (!form || !form.classList || !form.classList.contains('balnce-cart-upsell-form')) return;
    if (evt._balnceHandled) return;
    evt._balnceHandled = true;
    evt.preventDefault();
    evt.stopPropagation();
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;
    var btn = form.querySelector('[type="submit"]');
    addItemsToCart([{ id: idInput.value, quantity: 1 }], btn).catch(function () { /* handled */ });
  }
  document.addEventListener('submit', handleUpsellSubmit, true);

  function bindUpsellForms(root) {
    // Kept for backwards compatibility; les délégués ci-dessus sont ce qui
    // intercepte réellement sur chaque page / chaque re-render.
    (root || document).querySelectorAll('.balnce-cart-upsell-form').forEach(function (form) {
      form.dataset.balnceBound = '1';
    });
  }

  /* ─── v35 : qty=0 retire le line item ──────────────────────────
     Dawn's quantity-input + cart-items component rejettent les
     updates en dessous de quantity_rule.min (=1 pour la plupart des
     produits) avec le message "Cet article a un minimum de 1" → le
     panier ne se met jamais à jour.
     Notre fix : on écoute en capture phase les events qui pourraient
     amener à qty=0 (click minus quand val=1, change sur l'input avec
     val<=0) et on court-circuite pour appeler /cart/change.js avec
     quantity=0, ce qui retire le line item proprement.
     ─────────────────────────────────────────────────────────────── */

  function changeCartLine(line, quantity, triggerEl) {
    if (triggerEl) {
      triggerEl.setAttribute('aria-busy', 'true');
      triggerEl.classList.add('is-loading');
    }
    var payload = {
      line: line,
      quantity: quantity,
      sections: getSectionsToFetch(),
      sections_url: window.location.pathname
    };
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response && response.status && response.status !== 200) {
          console.error('[BALNCE_CART] /cart/change error:', response);
          return response;
        }
        var drawer = getCartDrawer();
        if (drawer && typeof drawer.renderContents === 'function' && response && response.sections) {
          drawer.renderContents(response);
        }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          dispatchCartUpdated(cart);
          return cart;
        });
      })
      .catch(function (err) {
        console.error('[BALNCE_CART] change error', err);
      })
      .finally(function () {
        if (triggerEl) {
          triggerEl.removeAttribute('aria-busy');
          triggerEl.classList.remove('is-loading');
        }
      });
  }

  function handleQtyMinusClick(evt) {
    var btn = evt.target && evt.target.closest
      ? evt.target.closest('cart-drawer .quantity__button[name="minus"]')
      : null;
    if (!btn) return;
    // Find the related input
    var wrapper = btn.closest('quantity-input') || btn.parentNode;
    if (!wrapper) return;
    var input = wrapper.querySelector('.quantity__input');
    if (!input) return;
    var cur = parseInt(input.value, 10);
    if (isNaN(cur) || cur > 1) return; // Dawn handles normal decrements
    // Current = 1, next would be 0 → we remove instead.
    var index = parseInt(input.getAttribute('data-index'), 10);
    if (!index) return;
    evt.preventDefault();
    evt.stopPropagation();
    if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
    changeCartLine(index, 0, btn);
  }

  function handleQtyInputChange(evt) {
    var input = evt.target;
    if (!input || !input.classList || !input.classList.contains('quantity__input')) return;
    if (!input.closest || !input.closest('cart-drawer')) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val > 0) return;
    var index = parseInt(input.getAttribute('data-index'), 10);
    if (!index) return;
    evt.preventDefault();
    evt.stopPropagation();
    if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
    changeCartLine(index, 0, input);
  }

  document.addEventListener('click', handleQtyMinusClick, true);
  document.addEventListener('change', handleQtyInputChange, true);

  /* ─── Observe drawer HTML updates (after renderContents) ─────── */

  function observeDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) return;
    var obs = new MutationObserver(function () {
      bindUpsellForms(drawer);
      // Re-wire shipping progress label if newly rendered
      fetch('/cart.js').then(function (r) { return r.json(); }).then(updateShippingProgress).catch(function () {});
      // Clear any stale Dawn error messages (they re-render from liquid)
      clearCartErrors();
    });
    obs.observe(drawer, { childList: true, subtree: true });
  }

  /* ─── Public API (backwards compat with balnce-behaviors.js) ── */

  window.BALNCE_CART = {
    open: openDrawer,
    close: function () {
      var d = getCartDrawer();
      if (d && typeof d.close === 'function') d.close();
    },
    add: function (variantId, qty) {
      return addItemsToCart([{ id: variantId, quantity: qty || 1 }]);
    },
    addItems: addItemsToCart,
    replaceLines: replaceCartLines,
    changeLine: changeCartLine,
    on: function (type, handler) { events.addEventListener(type, handler); },
    off: function (type, handler) { events.removeEventListener(type, handler); }
  };

  /* ─── Init ────────────────────────────────────────────────────── */

  function init() {
    bindPdpForm();
    bindNutriForm();
    bindProgrammeForm();
    bindUpsellForms(document);
    observeDrawer();
    // Clear any error string that Dawn rendered at page-load time
    clearCartErrors();
    // Initial shipping progress + header badge sync (v37.5)
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateShippingProgress(cart);
      updateHeaderCartBadge(cart);
      // v38-120 : DÉSACTIVÉ en v38-122 (race condition phantom display).
      // enforceMaxQtyDigital(cart);
    }).catch(function () { });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
